// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ecc5ce7f","228":"d8900080","310":"de9126e6","488":"29b71886","897":"f0e3f658","962":"13329438"}[chunkId] + ".chunk.js";
};